import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button, Form, Card } from 'react-bootstrap';
import { Link } from "react-router-dom"

import axios from 'axios'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
class AccountDetails extends Component {
    state = {
        addresses: []
    }
    componentDidMount() {
       this.getAddresses()
    }
    getAddresses=()=>{
         axios.get("/api/user/get/addresses").then((res) => {
            this.setState({ addresses: res.data.addresses })
        }
        )
    }
    deleteAddress = (id) => {
        axios.post("/api/user/delete/address", { id: id }).then((res) => {
            this.getAddresses()
        })
    }

    render() {
        let addresses = []
        this.state.addresses.forEach(address => {
            addresses.push(
                <div>
                    <Row>
                        Organisation: {address.Organisation}
                    </Row>
                    <Row>
                        FirstName: {address.FirstName}
                    </Row>
                    <Row>
                        LastName: {address.LastName}
                    </Row>
                    <Row>
                        AddressLine1: {address.AddressLine1}
                    </Row>
                    <Row>
                        AddressLine2: {address.AddressLine2}
                    </Row>
                    <Row>
                        City: {address.City}
                    </Row>
                    <Row>
                        State: {address.State}
                    </Row>
                    <Row>
                        CountryCode: {address.CountryCode}
                    </Row>
                    <Row>
                        ZipCode: {address.ZipCode}
                    </Row>
                    <Row>
                        Email: {address.Email}
                    </Row>
                    <Row>
                        Phone: +{address.PhoneCode} {address.PhoneNumber}
                    </Row>
                </div>
            )
            addresses.push(<Button onClick={() => this.deleteAddress(address._id)}>Remove</Button>)
            addresses.push(<hr />)

        });
        let darkmode = this.props.user ? this.props.user.darkmode : true

        return (
            <div>
                <Card style={{ width: '90%', margin: 'auto', display: 'block', marginTop: '60px', marginBottom: '60px' }}>
                    <Card.Header className={darkmode ? "darkmode-card-header" : "lightmode-card-header"} style={{ textAlign: 'center' }}>
                        <Row >
                            <Button as={Link} to='/account' style={{ marginLeft: '20px', backgroundColor: 'rgb(0, 123, 255)' }}><FontAwesomeIcon size='2x' icon={faArrowLeft} /></Button>
                            <h3 style={{ textAlign: 'center', margin: 'auto' }}>Account Addresses</h3>
                        </Row>
                    </Card.Header>
                    <Card.Body className={darkmode ? "darkmode-card-content" : "lightmode-card-content"} style={{ textAlign: 'center', paddingBottom: "20px" }}>
                        {addresses}


                    </Card.Body>
                </Card>



            </div>
        );
    }
}


function mapStateToProps(state) {
    return {
        user: state.user
    }
}
function mapDispatchToProps(dispatch) {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountDetails);